<template>
    <searchContainer :searchHandler="search" :resetHandler="reset">
        <template v-slot:items>
            <div class="row">
                <input-number v-model="filters.id" :options="{ id: 'id', step: 1, label: 'id' }"/>
                <input-text v-model="filters.id_number" :options="{ id: 'id_number', label: 'id_number' }"/>
                <select-countries v-model="filters.country_id" :options="{ id: 'country_id', label: 'country', action: countries_list_action, placeholder: 'placeholders.all' }"/>
                <select-cities v-model="filters.city_id" :country_id="filters.country_id" :options="{ id: 'city_id', label: 'city', action: cities_list_action, placeholder: 'placeholders.all' , disabled: !filters.country_id }"/>
                <input-text v-model="filters.mobile_number" :options="{ id: 'mobile_number', label: 'mobile_number' }"/>
                <select-captains-registration-requests-status v-model="filters.status" :options="{ id: 'captains_registration_requests_status', label: 'status', placeholder: 'placeholders.all' , multiple: true }"/>
            </div>
            <div class="row">
                <input-date v-model="filters.created_from" :options="{ id: 'created_from', label: 'created_from' }"/>
                <input-date v-model="filters.created_to" :options="{ id: 'created_to', label: 'created_to' }"/>
            </div>
        </template>
    </searchContainer>
</template>
<script>

    import {mapGetters} from "vuex";
    import {CRUD_SEARCH_RESET} from "actions/crud";
    import searchContainer from "@/components/crud/card/CardSearch";

    import {COUNTRIES_PUBLIC_LIST} from 'actions/countries';
    import {CITIES_PUBLIC_LIST} from 'actions/cities';

    const CRUD_CODE = "captains_registration_requests";
    export default {
        name: "CaptainRegistrationRequestSearch",
        components: {
            searchContainer
        },
        props: {
            listHandler: {
                type: Function,
                default: () => {
                }
            },
        },
        data() {
            return {
                transPrefix: CRUD_CODE,
                filters: {
                    country_id: this.getFilterByKey('country_id'),
                    city_id: this.getFilterByKey('city_id'),
                    status: this.getFilterByKey('status'),
                    mobile_number: this.getFilterByKey('mobile_number'),
                    id: this.getFilterByKey('id'),
                    id_number: this.getFilterByKey('id_number'),
                    created_from: this.getFilterByKey('created_from'),
                    created_to: this.getFilterByKey('created_to'),
                },
                filtersMap: {
                    country_id: 'countryId',
                    city_id: 'cityId',
                    status: 'statuses',
                    mobile_number: 'mobileNumber',
                    id: 'id',
                    id_number: 'idNumber',
                    created_from: 'startDate',
                    created_to: 'endDate',
                },
                countries_list_action: COUNTRIES_PUBLIC_LIST,
                cities_list_action: CITIES_PUBLIC_LIST,
            }
        },
        mounted() {
            this.setSearchParams(this.filters, this.filtersMap);
        },
        computed: {
            ...mapGetters([
                "getSearchFilters"
            ])
        },
        methods: {
            search() {
                this.resetPagination();
                this.setSearchParams(this.filters, this.filtersMap, {routeParams: this.getFilters(this.filters)});
                this.pushRoute(this.getSearchFilters);
                this.listHandler();
            },
            reset() {
                this.resetPagination();
                this.$store.dispatch(CRUD_SEARCH_RESET);
                this.filters = this.clearFilters(this.filters);
                this.pushRoute();
                this.listHandler();
            },
            resetPagination() {
                //Reset Pagination
                this.$emit('input', 0);
            },
            pushRoute(query = {}) {
                this.$router.push({name: this.$route.name, query}).catch(() => {});
            },
        }
    };
</script>
